export default __webpack_public_path__ + "static/media/Cancer_Icon.7acccefa.svg";